import React from 'react';
import { Menu, MenuItem, Divider, ListItemIcon, ListItemText, alpha } from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Print as PrintIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const ActionMenu = ({ 
  anchorEl, 
  onClose, 
  onEdit, 
  onPrint, 
  onDelete ,
  isFromPublishedTab
}) => {
  const theme = useTheme();
  
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.5)',
          borderRadius: 1
        }
      }}
    >
      {!isFromPublishedTab&&<MenuItem onClick={onEdit}>
        <ListItemIcon>
          <EditIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>}
      <MenuItem onClick={onPrint}>
        <ListItemIcon>
          <PrintIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />
        </ListItemIcon>
        <ListItemText>Print</ListItemText>
      </MenuItem>


      <Divider sx={{ borderColor: alpha(theme.palette.common.white, 0.1) }} />

      <MenuItem onClick={onDelete} sx={{ color: theme.palette.error.main }}>
        <ListItemIcon sx={{ color: theme.palette.error.main }}>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default ActionMenu;
